// Délai de livraison — texte validé par le client (juin 2026)
export const DELIVERY_NOTICE = {
  fr: {
    title: 'Délai de livraison : 2 à 3 semaines',
    text: 'Après votre commande, nous vous demandons votre logo et le lien URL à programmer sur la puce NFC. Une fois ces éléments reçus et la maquette validée, comptez un délai de 2 à 3 semaines pour la livraison. En cas de rupture de stock, comptez 4 à 5 semaines pour un produit avec marquage et lien URL intégré au bracelet, et 3 à 4 semaines pour un produit sans marquage ni lien.',
    q: 'Quel est le délai de livraison ?',
  },
  en: {
    title: 'Delivery time: 2 to 3 weeks',
    text: 'After your order, we ask you for your logo and the URL to program onto the NFC chip. Once we have received those and you have approved the artwork, allow 2 to 3 weeks for delivery. If an item is out of stock, allow 4 to 5 weeks for a product with branding and an integrated URL link, and 3 to 4 weeks for a product without branding or link.',
    q: 'What is the delivery time?',
  },
  ar: {
    title: 'مدة التسليم: من 2 إلى 3 أسابيع',
    text: 'بعد طلبك، نطلب منك شعارك ورابط الـ URL المراد برمجته على شريحة NFC. وبعد استلام هذين العنصرين والموافقة على التصميم، احسب مدة من 2 إلى 3 أسابيع للتسليم. في حال نفاد المخزون، احسب من 4 إلى 5 أسابيع للمنتج مع الطباعة ورابط URL مدمج في السوار، ومن 3 إلى 4 أسابيع للمنتج بدون طباعة أو رابط.',
    q: 'ما هي مدة التسليم؟',
  },
  it: {
    title: 'Tempi di consegna: 2 a 3 settimane',
    text: 'Dopo l\'ordine vi chiediamo il vostro logo e il link URL da programmare sul chip NFC. Una volta ricevuti questi elementi e approvata la bozza, contate 2 a 3 settimane per la consegna. In caso di esaurimento scorte, contate 4 a 5 settimane per un prodotto con marcatura e link URL integrato nel braccialetto, e 3 a 4 settimane per un prodotto senza marcatura né link.',
    q: 'Quali sono i tempi di consegna?',
  },
};
